export const GALLERY = '/gallery';
export const ABOUT   = '/about';
export const PRESS   = '/press';
export const CONTACT = '/contact';
export const ADMIN_LOGIN = '/login';
export const ADMIN = '/admin';
export const PAINTINGPAGE = '/painting/:id';
export const ADMINADDPAINTING = '/admin/add';
export const ADMINEDITPAINTING = '/admin/edit/:id';